/**
 * Go Green LED — Scroll Animations
 * IntersectionObserver-based reveal animations for elements
 * with data-animate, data-stagger, and data-delay attributes.
 */

document.addEventListener('DOMContentLoaded', () => {
  /* ------------------------------------------------------------------ */
  /*  Shared observer callback factory                                   */
  /* ------------------------------------------------------------------ */

  /**
   * Create an IntersectionObserver callback that adds the `animated`
   * class to every entry that crosses into view, then unobserves it.
   */
  function createRevealCallback() {
    return (entries, observer) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;

        const el = entry.target;

        // If a custom delay is specified, apply it as transition-delay
        const delay = el.getAttribute('data-delay');
        if (delay) {
          el.style.transitionDelay = delay;
        }

        el.classList.add('animated');
        observer.unobserve(el);
      });
    };
  }

  /* ------------------------------------------------------------------ */
  /*  Observer options                                                   */
  /* ------------------------------------------------------------------ */

  const observerOptions = {
    threshold: 0.15,
    rootMargin: '-60px',
  };

  /* ------------------------------------------------------------------ */
  /*  data-animate — single-element reveal                               */
  /* ------------------------------------------------------------------ */

  const animateElements = document.querySelectorAll('[data-animate]');

  if (animateElements.length) {
    const animateObserver = new IntersectionObserver(
      createRevealCallback(),
      observerOptions
    );

    animateElements.forEach((el) => animateObserver.observe(el));
  }

  /* ------------------------------------------------------------------ */
  /*  data-stagger — parent container whose children animate in sequence */
  /*  (Children receive stagger delays via CSS, e.g. nth-child rules.)   */
  /* ------------------------------------------------------------------ */

  const staggerElements = document.querySelectorAll('[data-stagger]');

  if (staggerElements.length) {
    const staggerObserver = new IntersectionObserver(
      createRevealCallback(),
      observerOptions
    );

    staggerElements.forEach((el) => staggerObserver.observe(el));
  }
});
